export default __webpack_public_path__ + "static/media/cryptopunks.883a8dc2.png";